let $ = require('jquery');
let Vue = require('vue');
let {url} = require('sci/utils');
let modal = require('sci/helpers/modal');

Vue.directive('map-modal', {
    priority: 1000,

    params: ['data'],

    bind: function () {
        $(this.el).click(() => {
            let {latitude, longitude} = this.params.data;

            if (!latitude || !longitude) {
                return;
            }

            let $modal = modal({
                title: `<i class="fa fa-map-marker modal-icon"></i> Mapa`,
                secondaryButton: null,
                primaryButton: 'Ok',
                width: 600,
                body: `<iframe src="${url("/utils/google-maps")}?latitude=${latitude}&longitude=${longitude}&title=imóvel" style="width: 100%;height: 400px;display: block;"></iframe>`,
                onShown: function ($modal) {
                    $modal.find('.modal-body').css('padding', 0);
                }
            });

            return false;
        });
    },
    update: function (value) {
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/map-modal.js